/* ==========================================================================
   QLMD — Facelift "3a · Asphalt Edel": storefront behaviour (theme "New Design Okt 2026")
   Loaded deferred via snippets/qlmd-head.liquid. No dependencies; delegated listeners, so cards that the
   theme re-renders (filters, recommendations) keep working.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     P4 · Product card quick add (snippets/product-grid-item.liquid)
     Uses the theme's own cart flow: POST theme.routes.cartAdd, then 'ajaxProduct:added' — Impulse's
     CartDrawer rebuilds, opens and updates every .cart-link__bubble-num (Akte §A). No own drawer code.
     ------------------------------------------------------------------------ */
  var OPEN = 'is-quick-open';
  var FALLBACK_ERROR = 'Konnte nicht hinzugefügt werden — bitte erneut versuchen.';

  function setOpen(card, open) {
    card.classList.toggle(OPEN, open);
    var plus = card.querySelector('[data-qlmd-plus]');
    if (plus) plus.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.qlmd-card.' + OPEN).forEach(function (card) {
      if (card !== except) setOpen(card, false);
    });
  }

  function showError(card, text) {
    var box = card.querySelector('.qlmd-card__error');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function addToBag(btn) {
    var card = btn.closest('.qlmd-card');
    if (!card || card.getAttribute('aria-busy') === 'true') return;
    var url = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';

    card.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    showError(card, '');

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          console.error('[qlmd] quick add refused', res.data);
          showError(card, res.data.description || res.data.message || FALLBACK_ERROR);
          return;
        }
        setOpen(card, false);
        // Same as the theme's AjaxProduct: on the cart page the page itself must refresh.
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: btn } }));
      })
      .catch(function (err) {
        console.error('[qlmd] quick add failed', err);
        showError(card, FALLBACK_ERROR);
      })
      .then(function () {
        card.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target instanceof Element ? evt.target : null;
    if (!target) return;

    var plus = target.closest('[data-qlmd-plus]');
    if (plus) {
      evt.preventDefault();
      var card = plus.closest('.qlmd-card');
      if (!card) return;
      var open = !card.classList.contains(OPEN);
      closeAll(card);
      setOpen(card, open);
      // Opened by keyboard (click event without pointer, detail 0): continue in the size row.
      if (open && evt.detail === 0) {
        var first = card.querySelector('[data-qlmd-add]');
        if (first) first.focus();
      }
      return;
    }

    var size = target.closest('[data-qlmd-add]');
    if (size) {
      evt.preventDefault();
      addToBag(size);
      return;
    }

    if (!target.closest('.qlmd-card.' + OPEN)) closeAll(null);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var active = document.activeElement;
    var card = active && active.closest ? active.closest('.qlmd-card.' + OPEN) : null;
    if (!card) return;
    setOpen(card, false);
    var plus = card.querySelector('[data-qlmd-plus]');
    if (plus) plus.focus();
  });
})();

/* ------------------------------------------------------------------------
   P5 · Collection page (sections/qlmd-collection.liquid)
   Without JS the page already works: every card of the page is visible, filters submit as GET forms,
   "Mehr laden" is a link to the next page. JS only adds: reveal in steps, auto-submit, drawer, dropdown closing.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  function senden(form) {
    if (!form) return;
    // Empty price fields would send "filter.v.price.gte=" — leave them out.
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.type === 'number' && el.value === '') el.disabled = true;
    });
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
  }

  function initCollection(root) {
    if (!root || root.dataset.qlmdInit) return;
    root.dataset.qlmdInit = '1';

    // Load more: first `erst` cards, then `mehr` per click; the next-page link only after this page's last card.
    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-qlmd-cell]'));
    var mehr = root.querySelector('[data-qlmd-mehr]');
    var knopf = root.querySelector('[data-qlmd-mehr-knopf]');
    var weiter = root.querySelector('[data-qlmd-mehr-weiter]');
    var erst = parseInt(root.dataset.erst, 10) || 10;
    var schritt = parseInt(root.dataset.mehr, 10) || 8;
    var shown = Math.min(erst, cells.length);

    function zeigen(fokusAb) {
      cells.forEach(function (c, i) { c.hidden = i >= shown; });
      if (mehr) {
        var offset = parseInt(mehr.dataset.offset, 10) || 0;
        var gesamt = parseInt(mehr.dataset.gesamt, 10) || cells.length;
        var bis = offset + shown;
        var bisEl = mehr.querySelector('[data-qlmd-mehr-bis]');
        var balken = mehr.querySelector('[data-qlmd-mehr-balken]');
        if (bisEl) bisEl.textContent = String(bis);
        if (balken) balken.style.width = (gesamt ? Math.min(100, (bis / gesamt) * 100) : 100) + '%';
        var rest = shown < cells.length;
        if (knopf) knopf.hidden = !rest;
        if (weiter) weiter.hidden = rest;
      }
      // Keyboard/screen-reader users continue at the first newly shown card.
      if (typeof fokusAb === 'number' && cells[fokusAb]) {
        var link = cells[fokusAb].querySelector('.qlmd-card__meta');
        if (link) link.focus();
      }
    }
    if (knopf) {
      knopf.addEventListener('click', function () {
        var von = shown;
        shown = Math.min(shown + schritt, cells.length);
        zeigen(von);
      });
    }
    zeigen();

    // Sort + desktop dropdowns submit the "drop" form; the drawer submits its own form on "… Produkte zeigen".
    var dropForm = root.querySelector('[data-qlmd-filterform="drop"]');
    var drawerForm = root.querySelector('[data-qlmd-filterform="drawer"]');
    [dropForm, drawerForm].forEach(function (f) {
      if (!f) return;
      f.addEventListener('submit', function () {
        Array.prototype.forEach.call(f.elements, function (el) {
          if (el.type === 'number' && el.value === '') el.disabled = true;
        });
      });
    });
    var sort = root.querySelector('[data-qlmd-sort]');
    if (sort && dropForm) {
      sort.addEventListener('change', function () {
        var label = root.querySelector('[data-qlmd-sort-label]');
        if (label) label.textContent = sort.options[sort.selectedIndex].text;
        senden(dropForm);
      });
    }
    var drops = Array.prototype.slice.call(root.querySelectorAll('[data-qlmd-drop]'));
    drops.forEach(function (d) {
      d.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () { senden(dropForm); });
      });
      d.addEventListener('toggle', function () {
        if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (evt) {
      drops.forEach(function (d) { if (d.open && !d.contains(evt.target)) d.open = false; });
    });
    root.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape') return;
      drops.forEach(function (d) {
        if (!d.open) return;
        d.open = false;
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });

    // Filter drawer: native <dialog> (focus trap, Escape, focus return); page scroll locked while open.
    var dlg = root.querySelector('[data-qlmd-fdrawer]');
    var auf = root.querySelector('[data-qlmd-filter-open]');
    if (dlg && auf && typeof dlg.showModal === 'function') {
      auf.addEventListener('click', function () {
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      dlg.querySelectorAll('[data-qlmd-filter-close]').forEach(function (b) {
        b.addEventListener('click', function () { dlg.close(); });
      });
      // A click on the backdrop targets the dialog itself (its content fills the panel).
      dlg.addEventListener('click', function (evt) { if (evt.target === dlg) dlg.close(); });
    }
  }

  document.querySelectorAll('[data-qlmd-coll]').forEach(initCollection);
  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-qlmd-coll]') : null;
    if (root) initCollection(root);
  });
})();

/* ------------------------------------------------------------------------
   P6 · Product page + P7 overlays (sections/qlmd-product.liquid)
   Without JS the form still buys (radios name="id" + native required). JS adds: status/CTA/price per size,
   "Fast weg", own error text, add via the theme cart flow, gallery, zoom, size chart, sticky bar.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var FALLBACK_ERROR = 'Konnte nicht hinzugefügt werden — bitte erneut versuchen.';

  function initPdp(root) {
    if (!root || root.dataset.qlmdInit) return;
    root.dataset.qlmdInit = '1';

    var schwelle = parseInt(root.dataset.schwelle, 10) || 5;
    var varianten = [];
    try {
      var daten = root.querySelector('[data-qlmd-varianten]');
      varianten = daten ? JSON.parse(daten.textContent) : [];
    } catch (err) {
      console.error('[qlmd] variant data unreadable', err);
    }
    var form = root.querySelector('[data-qlmd-form]');
    var kaufen = root.querySelector('[data-qlmd-kaufen]');
    var fehler = root.querySelector('[data-qlmd-fehler]');
    var preis = root.querySelector('[data-qlmd-preis]');
    var statt = root.querySelector('[data-qlmd-statt]');
    var lager = root.querySelector('[data-qlmd-lager]');
    var gruppen = Array.prototype.slice.call(root.querySelectorAll('[data-qlmd-gruppe]'));
    var hiddenId = root.querySelector('[data-qlmd-variante]');
    var mehrereOptionen = !!hiddenId;
    var leiste = root.querySelector('[data-qlmd-leiste]');

    if (form) form.setAttribute('novalidate', '');
    if (hiddenId) hiddenId.disabled = false;

    function gewaehlteVariante() {
      if (!mehrereOptionen) {
        var r = root.querySelector('input[name="id"]:checked');
        if (r) return varianten.find(function (v) { return String(v.id) === r.value; }) || null;
        var fest = form ? form.querySelector('input[type="hidden"][name="id"]') : null;
        return fest && fest.value ? varianten.find(function (v) { return String(v.id) === fest.value; }) || null : null;
      }
      var werte = gruppen.map(function (g) {
        var r = g.querySelector('input[type="radio"]:checked');
        return r ? r.value : null;
      });
      if (werte.indexOf(null) !== -1) return null;
      return varianten.find(function (v) {
        return v.o.every(function (o, i) { return o === werte[i]; });
      }) || null;
    }

    function setLager(art, html) {
      if (!lager) return;
      var punkt = lager.querySelector('.qlmd-status__punkt');
      var text = lager.querySelector('[data-qlmd-lager-text]');
      if (punkt) punkt.className = 'qlmd-status__punkt qlmd-status__punkt--' + art;
      if (text) {
        text.className = 'qlmd-status__text' + (art === 'ok' ? ' qlmd-status__text--ok' : art === 'knapp' ? ' qlmd-status__text--knapp' : '');
        text.innerHTML = html;
      }
    }

    function fehlerZeigen(text) {
      if (!fehler) return;
      fehler.textContent = text || '';
      fehler.hidden = !text;
      gruppen.forEach(function (g) {
        var st = g.querySelector('[data-qlmd-gr-status]');
        if (!st) return;
        var gewaehlt = g.querySelector('input[type="radio"]:checked');
        st.classList.toggle('is-fehler', !!text && !gewaehlt);
        if (text && !gewaehlt) st.textContent = 'Bitte zuerst eine Größe wählen';
      });
    }

    function aktualisieren() {
      var v = gewaehlteVariante();
      gruppen.forEach(function (g) {
        var st = g.querySelector('[data-qlmd-gr-status]');
        var r = g.querySelector('input[type="radio"]:checked');
        if (st) {
          st.classList.remove('is-fehler');
          st.textContent = r ? (r.dataset.label + ' gewählt') : 'Bitte wählen';
        }
      });
      if (hiddenId) hiddenId.value = v ? String(v.id) : '';
      if (v) {
        if (preis) {
          preis.textContent = v.p;
          preis.classList.toggle('is-sale', !!v.c);
        }
        if (statt) {
          statt.textContent = v.c || '';
          statt.hidden = !v.c;
        }
        var label = v.o.join(' / ');
        if (!v.a) {
          setLager('aus', '<b>Ausverkauft</b> — Größe ' + label);
        } else if (v.q > 0 && v.q <= schwelle) {
          setLager('knapp', '<b>Fast weg</b> — nur noch ' + v.q + ' Stück in Größe ' + label);
        } else {
          setLager('ok', '<b>Auf Lager</b> — sofort lieferbar');
        }
        if (kaufen) {
          kaufen.disabled = !v.a;
          kaufen.textContent = v.a ? 'In den Warenkorb — ' + v.p : 'Ausverkauft';
        }
        fehlerZeigen('');
      } else if (kaufen && kaufen.dataset.text && !kaufen.disabled) {
        kaufen.textContent = kaufen.dataset.text;
      }
      leisteAktualisieren(v);
    }

    root.addEventListener('change', function (evt) {
      if (evt.target && evt.target.classList && evt.target.classList.contains('qlmd-gr__input')) aktualisieren();
    });

    function inDenBag() {
      var v = gewaehlteVariante();
      if (!v) {
        fehlerZeigen('Bitte zuerst eine Größe wählen');
        var erste = root.querySelector('.qlmd-gr__input:not(:disabled)');
        if (erste) {
          erste.closest('.qlmd-gr').scrollIntoView({ block: 'center', behavior: 'smooth' });
          erste.focus({ preventScroll: true });
        }
        return;
      }
      if (!v.a || !kaufen || kaufen.classList.contains('is-loading')) return;
      var url = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
      kaufen.classList.add('is-loading');
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            console.error('[qlmd] add to bag refused', res.data);
            fehlerZeigen(res.data.description || res.data.message || FALLBACK_ERROR);
            return;
          }
          fehlerZeigen('');
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: kaufen } }));
        })
        .catch(function (err) {
          console.error('[qlmd] add to bag failed', err);
          fehlerZeigen(FALLBACK_ERROR);
        })
        .then(function () { kaufen.classList.remove('is-loading'); });
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        inDenBag();
      });
    }

    /* Sticky bar (P7): visible once the main button has scrolled out above the viewport. */
    function leisteAktualisieren(v) {
      if (!leiste) return;
      var lp = leiste.querySelector('[data-qlmd-leiste-preis]');
      var lg = leiste.querySelector('[data-qlmd-leiste-groesse]');
      if (lp && v) lp.textContent = v.p;
      if (lg) lg.textContent = v ? 'Größe ' + v.o.join(' / ') : 'Größe wählen';
      leiste.querySelectorAll('[data-qlmd-leiste-wahl]').forEach(function (b) {
        b.setAttribute('aria-pressed', v && String(v.id) === b.dataset.qlmdLeisteWahl ? 'true' : 'false');
      });
    }
    if (leiste && kaufen) {
      // Measured on every scroll frame, not with an IntersectionObserver: when the page JUMPS from 'button below
      // the viewport' to 'button above' (anchor, restored scroll position, fast fling) the intersection state never
      // changes and the observer stays silent — the bar never appeared on mobile (17.10.2026).
      var geplant = false;
      var leistePruefen = function () {
        geplant = false;
        var zeigen = kaufen.getBoundingClientRect().bottom < 0;
        if (leiste.hidden === zeigen) {
          leiste.hidden = !zeigen;
          document.body.classList.toggle('qlmd-leiste-offen', zeigen);
        }
      };
      window.addEventListener('scroll', function () {
        if (!geplant) { geplant = true; window.requestAnimationFrame(leistePruefen); }
      }, { passive: true });
      window.addEventListener('resize', leistePruefen);
      leistePruefen();
      leiste.addEventListener('click', function (evt) {
        var wahl = evt.target.closest('[data-qlmd-leiste-wahl]');
        if (wahl) {
          var radio = root.querySelector('input[name="id"][value="' + wahl.dataset.qlmdLeisteWahl + '"]');
          if (radio && !radio.disabled) {
            radio.checked = true;
            aktualisieren();
          }
          return;
        }
        if (evt.target.closest('[data-qlmd-leiste-kaufen]')) inDenBag();
      });
    }

    /* Gallery: mobile tap = next image (scroll-snap row), line dots follow; desktop click = zoom. */
    var reihe = root.querySelector('[data-qlmd-bilder]');
    var bilder = Array.prototype.slice.call(root.querySelectorAll('[data-qlmd-bild]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.qlmd-pdp__dot'));
    var mobil = window.matchMedia('(max-width: 768px)');
    function aktuellerIndex() {
      if (!reihe || !reihe.clientWidth) return 0;
      return Math.round(reihe.scrollLeft / reihe.clientWidth);
    }
    if (reihe) {
      reihe.addEventListener('scroll', function () {
        var i = aktuellerIndex();
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    }
    root.addEventListener('click', function (evt) {
      var knopf = evt.target.closest('[data-qlmd-bildknopf]');
      if (knopf) {
        var i = parseInt(knopf.dataset.qlmdBildknopf, 10) || 0;
        if (mobil.matches && bilder.length > 1) {
          reihe.scrollTo({ left: ((i + 1) % bilder.length) * reihe.clientWidth, behavior: 'smooth' });
        } else {
          zoomOeffnen(i);
        }
        return;
      }
      if (evt.target.closest('[data-qlmd-lupe]')) zoomOeffnen(aktuellerIndex());
      if (evt.target.closest('[data-qlmd-gt-open]')) gtOeffnen();
    });

    /* Zoom dialog (P7). */
    var zoom = root.querySelector('[data-qlmd-zoom]');
    var zoomIndex = 0;
    function zoomZeigen(i) {
      if (!zoom || !bilder.length) return;
      zoomIndex = (i + bilder.length) % bilder.length;
      var bild = zoom.querySelector('[data-qlmd-zoom-bild]');
      bild.classList.remove('is-zoom');
      bild.style.backgroundPosition = '';
      bild.style.backgroundImage = 'url("' + bilder[zoomIndex].dataset.gross + '")';
      zoom.querySelector('[data-qlmd-zoom-zaehler]').textContent = (zoomIndex + 1) + ' / ' + bilder.length;
      var hinweis = zoom.querySelector('[data-qlmd-zoom-hinweis]');
      if (hinweis) hinweis.textContent = mobil.matches ? 'Antippen zum Zoomen' : 'Klicken zum Zoomen';
      zoom.querySelectorAll('.qlmd-zoom__thumb').forEach(function (t, k) {
        t.setAttribute('aria-current', k === zoomIndex ? 'true' : 'false');
      });
    }
    function zoomOeffnen(i) {
      if (!zoom || typeof zoom.showModal !== 'function') return;
      var thumbs = zoom.querySelector('[data-qlmd-zoom-thumbs]');
      if (thumbs && !thumbs.children.length) {
        bilder.forEach(function (b, k) {
          var t = document.createElement('button');
          t.type = 'button';
          t.className = 'qlmd-zoom__thumb';
          t.setAttribute('aria-label', 'Bild ' + (k + 1));
          t.style.backgroundImage = 'url("' + b.dataset.klein + '")';
          t.addEventListener('click', function () { zoomZeigen(k); });
          thumbs.appendChild(t);
        });
      }
      zoomZeigen(i);
      zoom.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    if (zoom) {
      zoom.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      zoom.querySelector('[data-qlmd-zoom-zu]').addEventListener('click', function () { zoom.close(); });
      var zur = zoom.querySelector('[data-qlmd-zoom-zurueck]');
      var vor = zoom.querySelector('[data-qlmd-zoom-vor]');
      if (zur) zur.addEventListener('click', function () { zoomZeigen(zoomIndex - 1); });
      if (vor) vor.addEventListener('click', function () { zoomZeigen(zoomIndex + 1); });
      var zbild = zoom.querySelector('[data-qlmd-zoom-bild]');
      zbild.addEventListener('click', function () {
        var an = !zbild.classList.contains('is-zoom');
        zbild.classList.toggle('is-zoom', an);
        zbild.setAttribute('aria-label', an ? 'Verkleinern' : 'Zoomen');
        if (!an) zbild.style.backgroundPosition = '';
        var hinweis = zoom.querySelector('[data-qlmd-zoom-hinweis]');
        if (hinweis) hinweis.textContent = an ? (mobil.matches ? 'Antippen zum Verkleinern' : 'Klicken zum Verkleinern') : (mobil.matches ? 'Antippen zum Zoomen' : 'Klicken zum Zoomen');
      });
      zbild.addEventListener('mousemove', function (evt) {
        if (!zbild.classList.contains('is-zoom')) return;
        var r = zbild.getBoundingClientRect();
        zbild.style.backgroundPosition = ((evt.clientX - r.left) / r.width * 100) + '% ' + ((evt.clientY - r.top) / r.height * 100) + '%';
      });
      zoom.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowLeft') zoomZeigen(zoomIndex - 1);
        if (evt.key === 'ArrowRight') zoomZeigen(zoomIndex + 1);
      });
    }

    /* Size chart dialog (P7): cm/inch, highlighted row = chosen size (else M). */
    var gt = root.querySelector('[data-qlmd-gt]');
    function gtOeffnen() {
      if (!gt || typeof gt.showModal !== 'function') return;
      var v = gewaehlteVariante();
      var groesse = v ? String(v.o[0]).toUpperCase() : 'M';
      var alias = { '2XL': 'XXL', '3XL': 'XXXL' };
      groesse = alias[groesse] || groesse;
      gt.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.classList.toggle('is-markiert', tr.dataset.groesse === groesse);
      });
      gt.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    if (gt) {
      gt.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      gt.querySelector('[data-qlmd-gt-zu]').addEventListener('click', function () { gt.close(); });
      gt.addEventListener('click', function (evt) { if (evt.target === gt) gt.close(); });
      gt.querySelectorAll('[data-qlmd-einheit]').forEach(function (knopf) {
        knopf.addEventListener('click', function () {
          var inch = knopf.dataset.qlmdEinheit === 'inch';
          gt.querySelectorAll('[data-qlmd-einheit]').forEach(function (k) { k.setAttribute('aria-pressed', k === knopf ? 'true' : 'false'); });
          gt.querySelectorAll('td[data-cm]').forEach(function (td) {
            var cm = parseFloat(td.dataset.cm);
            var wert = inch ? Math.round((cm / 2.54) * 10) / 10 : cm;
            td.textContent = String(wert).replace('.', ',');
          });
        });
      });
    }

    aktualisieren();
  }

  /* "Passt dazu": swap the server-rendered fallback for Shopify's product recommendations. */
  function initEmpfehlungen(sektion) {
    if (!sektion || sektion.dataset.qlmdInit) return;
    sektion.dataset.qlmdInit = '1';
    var url = sektion.dataset.url;
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neu = doc.querySelector('[data-qlmd-empf-grid]');
        var alt = sektion.querySelector('[data-qlmd-empf-grid]');
        if (neu && alt && neu.querySelectorAll('.qlmd-card').length >= 2) alt.innerHTML = neu.innerHTML;
      })
      .catch(function (err) { console.error('[qlmd] recommendations failed', err); });
  }

  document.querySelectorAll('[data-qlmd-pdp]').forEach(initPdp);
  document.querySelectorAll('[data-qlmd-empf]').forEach(initEmpfehlungen);
  document.addEventListener('shopify:section:load', function (evt) {
    var t = evt.target;
    if (!t || !t.querySelector) return;
    initPdp(t.querySelector('[data-qlmd-pdp]'));
    initEmpfehlungen(t.querySelector('[data-qlmd-empf]'));
  });
})();

/* ------------------------------------------------------------------------
   P8 · Bag drawer (snippets/cart-drawer.liquid) — the theme still builds, opens and counts (theme.CartForm,
   theme.Drawers). JS here only adds: the confirmation line after an add, remove in place (and "−" at 1 = remove),
   "Passt dazu" with 2 suggestions from Shopify's recommendations (size chips → theme add flow).
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !drawer.classList.contains('qlmd-bag')) return;
  var ok = drawer.querySelector('[data-qlmd-bag-ok]');
  var empf = drawer.querySelector('[data-qlmd-bag-empf]');
  var empfListe = drawer.querySelector('[data-qlmd-bag-empf-liste]');
  var produkte = drawer.querySelector('[data-products]');
  var routes = (window.theme && window.theme.routes) || {};
  var HAKEN = '<svg class="qlmd-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M4.5 12.5l5 5 10-11"/></svg>';

  function text(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function geld(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings) return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Confirmation line after every add (card, product page, sticky bar, suggestions).
  document.addEventListener('ajaxProduct:added', function (evt) {
    var p = evt.detail && evt.detail.product;
    if (!ok || !p) return;
    var titel = p.product_title || p.title || '';
    var variante = p.variant_title && p.variant_title !== 'Default Title' ? ' · ' + p.variant_title : '';
    ok.innerHTML = HAKEN + '<span>' + text(titel + variante) + ' wurde hinzugefügt</span>';
    ok.hidden = false;
  });
  // ...and gone once the drawer closes.
  new MutationObserver(function () {
    if (!drawer.classList.contains('drawer--is-open') && ok) ok.hidden = true;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  // Remove in place: the theme's link would leave the page (/cart/change → /cart).
  function entfernen(key, ausloeser) {
    var url = routes.cartChange || '/cart/change.js';
    if (ok) ok.hidden = true; // an 'added' confirmation must not stand over a line that is gone
    if (ausloeser) ausloeser.setAttribute('aria-busy', 'true');
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (err) { console.error('[qlmd] remove failed', err); window.location.href = routes.cartPage || '/cart'; });
  }
  drawer.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-qlmd-entfernen]');
    if (link) {
      evt.preventDefault();
      entfernen(link.dataset.qlmdEntfernen, link);
      return;
    }
    // "−" at quantity 1: the theme ignores quantity 0 (CartForm returns early) — treat it as remove.
    var minus = evt.target.closest('.js-qty__adjust--minus');
    if (minus) {
      var feld = minus.parentNode.querySelector('.js-qty__num');
      if (feld && parseInt(feld.value, 10) <= 1) {
        evt.stopImmediatePropagation();
        entfernen(feld.dataset.id, minus);
      }
    }
  }, true);

  // "Passt dazu": recommendations of the first line, minus what is in the bag; 2 available products.
  var letzteBasis = null;
  function vorschlaege() {
    if (!empf || !empfListe || !produkte) return;
    var zeilen = Array.prototype.slice.call(produkte.querySelectorAll('[data-produkt]'));
    if (!zeilen.length) { empf.hidden = true; letzteBasis = null; return; }
    var imBag = zeilen.map(function (z) { return z.dataset.produkt; });
    var basis = imBag[0];
    if (basis === letzteBasis) return;
    letzteBasis = basis;
    var url = (routes.productRecommendations || '/recommendations/products') + '.json?product_id=' + basis + '&limit=8';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (data) {
        var liste = (data.products || []).filter(function (p) {
          return p.available && imBag.indexOf(String(p.id)) === -1;
        }).slice(0, 2);
        if (!liste.length) { empf.hidden = true; return; }
        empfListe.innerHTML = liste.map(function (p) {
          var bild = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=140' : '';
          return '<div class="qlmd-bag__vorschlag" data-qlmd-vorschlag="' + p.id + '">' +
            (bild ? '<img class="qlmd-bag__vorschlag-bild" src="' + text(bild) + '" alt="" loading="lazy" width="56" height="70">' : '<span class="qlmd-bag__vorschlag-bild"></span>') +
            '<div class="qlmd-bag__vorschlag-info">' +
            '<a class="qlmd-bag__vorschlag-name" href="' + text(p.url) + '">' + text(p.title) + '</a>' +
            '<span class="qlmd-bag__vorschlag-preis">' + geld(p.price) + '</span>' +
            '<button type="button" class="qlmd-bag__vorschlag-knopf" data-qlmd-vorschlag-auf>Hinzufügen</button>' +
            '<div class="qlmd-bag__vorschlag-groessen" role="group" aria-label="Größe wählen" hidden>' +
            p.variants.map(function (v) {
              return '<button type="button" class="qlmd-bag__vorschlag-groesse" data-qlmd-vorschlag-v="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + text(v.title === 'Default Title' ? 'Hinzufügen' : v.title) + '</button>';
            }).join('') +
            '</div></div></div>';
        }).join('');
        empf.hidden = false;
      })
      .catch(function (err) { console.error('[qlmd] bag suggestions failed', err); empf.hidden = true; });
  }
  if (produkte) new MutationObserver(vorschlaege).observe(produkte, { childList: true });

  drawer.addEventListener('click', function (evt) {
    var auf = evt.target.closest('[data-qlmd-vorschlag-auf]');
    if (auf) {
      var gruppe = auf.parentNode.querySelector('.qlmd-bag__vorschlag-groessen');
      var einzig = gruppe.querySelectorAll('[data-qlmd-vorschlag-v]');
      // One variant only: add straight away; otherwise show the sizes in place of the button.
      if (einzig.length === 1) { einzig[0].click(); return; }
      auf.hidden = true;
      gruppe.hidden = false;
      var erste = gruppe.querySelector('button:not(:disabled)');
      if (erste) erste.focus();
      return;
    }
    var v = evt.target.closest('[data-qlmd-vorschlag-v]');
    if (!v) return;
    v.setAttribute('aria-busy', 'true');
    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(v.dataset.qlmdVorschlagV), quantity: 1 })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { console.error('[qlmd] suggestion add refused', res.data); v.removeAttribute('aria-busy'); return; }
        letzteBasis = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: v } }));
      })
      .catch(function (err) { console.error('[qlmd] suggestion add failed', err); v.removeAttribute('aria-busy'); });
  });
})();

/* ------------------------------------------------------------------------
   Mobile menu M1/M2 (snippets/qlmd-menu-drawer.liquid, CEO 18.10.2026) — Impulse's theme.Drawers still opens and
   closes #NavDrawer (Esc, aria-expanded on the burger, focus back to it). Added here: level 2 slides in from the
   right (280 ms, instant with prefers-reduced-motion), a focus trap that also holds Tab (Impulse only wraps
   Shift+Tab on its first element), the page scroll lock (Impulse's .lock-scroll has no CSS), level 1 again after
   closing, and the bag icon opening the cart drawer.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var drawer = document.getElementById('NavDrawer');
  if (!drawer || !drawer.classList.contains('qmd')) return;
  var scroller = drawer.querySelector('[data-qmd-scroll]');
  var ebene1 = drawer.querySelector('[data-qmd-ebene="1"]');
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DAUER = 280;
  var KLASSEN = ['qmd__ebene--weg', 'qmd__ebene--links', 'qmd__ebene--rechts', 'qmd__ebene--sofort'];
  var offen = null;      // open level-2 panel
  var ausloeser = null;  // level-1 row that opened it
  var lauf = 0;          // newest level change; timers of older ones stand down
  var zuTimer = null;

  function istOffen() { return drawer.classList.contains('drawer--is-open'); }

  function sauber(el) {
    KLASSEN.forEach(function (k) { el.classList.remove(k); });
    el.removeAttribute('inert');
  }

  // rein = incoming level, raus = outgoing one; vor = one level deeper (the new level comes from the right).
  // The outgoing level leaves the flow, so the box takes the height of the incoming one at once.
  function wechseln(rein, raus, vor) {
    var still = ruhig.matches;
    var mein = ++lauf;
    drawer.querySelectorAll('[data-qmd-ebene]').forEach(function (e) {
      sauber(e);
      if (e !== rein && e !== raus) e.hidden = true;
    });
    rein.hidden = false;
    raus.hidden = false;
    raus.setAttribute('inert', '');
    raus.classList.add('qmd__ebene--weg');
    if (!still) {
      rein.classList.add('qmd__ebene--sofort', vor ? 'qmd__ebene--rechts' : 'qmd__ebene--links');
      void rein.offsetWidth;
      rein.classList.remove('qmd__ebene--sofort', 'qmd__ebene--rechts', 'qmd__ebene--links');
      raus.classList.add(vor ? 'qmd__ebene--links' : 'qmd__ebene--rechts');
    }
    scroller.scrollTop = 0;
    window.setTimeout(function () {
      if (mein !== lauf) return;
      raus.hidden = true;
      sauber(raus);
    }, still ? 0 : DAUER);
  }

  function aufklappen(knopf) {
    var ziel = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!ziel) return;
    if (ausloeser && ausloeser !== knopf) ausloeser.setAttribute('aria-expanded', 'false');
    ausloeser = knopf;
    offen = ziel;
    knopf.setAttribute('aria-expanded', 'true');
    wechseln(ziel, ebene1, true);
    var zurueck = ziel.querySelector('[data-qmd-zurueck]');
    if (zurueck) zurueck.focus({ preventScroll: true });
  }

  function zuklappen() {
    if (!offen) return;
    var panel = offen;
    offen = null;
    wechseln(ebene1, panel, false);
    if (ausloeser) {
      ausloeser.setAttribute('aria-expanded', 'false');
      ausloeser.focus({ preventScroll: true });
    }
  }

  function zuruecksetzen() {
    lauf += 1;
    offen = null;
    if (ausloeser) ausloeser.setAttribute('aria-expanded', 'false');
    ausloeser = null;
    drawer.querySelectorAll('[data-qmd-ebene]').forEach(function (e) {
      sauber(e);
      e.hidden = e !== ebene1;
    });
    scroller.scrollTop = 0;
  }

  // Bag icon: close the menu, then open the cart drawer through the header bag (bound by Impulse's CartDrawer).
  // Without a cart drawer (cart page) the link simply goes to /cart.
  function zumWarenkorb(evt) {
    var kopfBag = document.querySelector('#SiteHeader .qlmd-header-bag');
    var nav = window.theme && window.theme.NavDrawer;
    if (!kopfBag || !nav || !document.getElementById('CartDrawer') || document.body.classList.contains('template-cart')) return;
    evt.preventDefault();
    // Impulse would focus the burger 500 ms after closing — by then the cart drawer has the focus
    if (nav.activeSource) {
      nav.activeSource.setAttribute('aria-expanded', 'false');
      nav.activeSource = null;
    }
    nav.close();
    kopfBag.click();
  }

  drawer.addEventListener('click', function (evt) {
    var auf = evt.target.closest('[data-qmd-auf]');
    if (auf) { aufklappen(auf); return; }
    if (evt.target.closest('[data-qmd-zurueck]')) { zuklappen(); return; }
    if (evt.target.closest('[data-qmd-bag]')) zumWarenkorb(evt);
  });

  function ziele() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null && !el.closest('[inert]'); }
    );
  }

  drawer.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Tab' || !istOffen()) return;
    var z = ziele();
    if (!z.length) return;
    var jetzt = document.activeElement;
    if (evt.shiftKey && (jetzt === z[0] || jetzt === drawer)) {
      evt.preventDefault();
      z[z.length - 1].focus();
    } else if (!evt.shiftKey && jetzt === z[z.length - 1]) {
      evt.preventDefault();
      z[0].focus();
    }
  });

  // Focus that lands outside while the menu is open (screen reader, script) comes back into the menu
  document.addEventListener('focusin', function (evt) {
    if (!istOffen() || drawer.contains(evt.target)) return;
    var z = ziele();
    (z[0] || drawer).focus({ preventScroll: true });
  });

  // Open/closed comes from Impulse (class drawer--is-open): lock the page, back to level 1 once it has slid out
  new MutationObserver(function () {
    var auf = istOffen();
    document.documentElement.classList.toggle('qmd-gesperrt', auf);
    window.clearTimeout(zuTimer);
    if (!auf) zuTimer = window.setTimeout(zuruecksetzen, 500);
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
